//
//
//
//
//
//

export default {
  name: 'ffbtn',
  props:{
    moduid:{
      type:String,
      default:""
    },
    idname:{
      type:String,
      default:"ID_bt_add"
    },

  },
  data() {
    return {
      btnShow:true//控制按钮是否显示
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
  watch:{
    moduid:{
      immediate: true,
      handler () {
        if(undefined!=this.moduid && this.moduid!="" && this.moduid!=null){
          let url = "modu/checkRightlevel";
          let params = {
            pub_moduid:this.moduid
          };
          this.axios.post(url, params).then(({ data }) => {
            if(data.code=="1" && data.data!="2"){
              this.btnShow=false;
            }else{
              this.btnShow=true;
            }
          }).catch((error)=>{
            this.btnShow=false;
            console.log('2019年11月12日21:09:32 ffbtn.vue[描述]——[error] :',error);
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/ffbtn.vue